import React from "react";
import {
    Box,
    Collapse,
    Flex,
    IconButton,
    Link,
    Spacer,
    Stack,
    useDisclosure
} from "@chakra-ui/react";
import { FaBars, FaTimes } from "react-icons/fa";

import "../styles/navbar.css";

import Logo from "./Logo";
import items from "../data/navbar.json";


function NavToggle(props) {
    const { isOpen, toggle, ...rest } = props;

    return (
        <IconButton
            className={"navbar-toggle"}
            onClick={toggle}
            aspectRatio={1}
            height={"100%"}
            variant={"unstyled"}
            aria-label={"Toggle Navbar"}
            icon={ isOpen ? <FaTimes /> : <FaBars /> }
            {...rest}
        />
    );
}

function NavItem(props) {
    const { item, ...rest } = props;

    return (
        <Link
            className={"navbar-item"}
            href={item.href ?? "#"}
            {...rest}
        >
            {item.label}
        </Link>
    );
}

function NavItems(props) {
    return <Stack spacing={0} {...props}>
        {items.map((item, i) => (
            <NavItem item={item} key={i} />
        ))}
    </Stack>
}

export default function Navbar(props) {
    const { height = "64px" } = props
    const { isOpen, onToggle } = useDisclosure(false);

    return (
        <Box
            className={"navbar"}
            height={height}
            lineHeight={height}
        >
            <Flex className={"container"}>
                <Logo />
                <Spacer />
                <NavItems
                    direction={"row"}
                    display={{ base: "none", md: "flex" }}
                />
                <NavToggle 
                    isOpen={isOpen}
                    toggle={onToggle}
                    display={{ base: "block", md: "none" }}
                />
            </Flex>
            <Collapse in={isOpen} animateOpacity>
                <NavItems
                    direction={"column"}
                    display={{ base: "flex", md: "none" }}
                />
            </Collapse>
        </Box>
    );
}
